import React from "react";
import { useQuery } from 'react-query'
import { getResultRSC_H2H } from "data/Querys"
import Loader from 'components/general/Loader'
import NotAvailable from "components/common/NotAvailable";
import PageHeader from "components/common/PageHeader";
import WreScore from "components/sports/wre/WreScore";
import WreSummary from "components/sports/wre/WreSummary";
import Referees from "components/general/Referees";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const WreContext = () => {
  const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()

  //datos para el marcador y estadisticas
  const { data, isError, isLoading } = useQuery(
    {
      queryKey: ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language],
      queryFn: getResultRSC_H2H,
      refetchInterval: 5000,
      staleTime: 5000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error']
    });

  if (isLoading) { return <Loader />; }
  if (isError) { return <NotAvailable />; }
  if (!data?.results) { return <NotAvailable /> }

  return (
    <>
      <PageHeader data={data} />
      <div className='mirs-page-container'>
      <WreScore data={data} />
      <WreSummary data={data} />
      <Referees data={data?.results?.officials} showHeader={true} />
      </div>
    </>
  );
};

export default WreContext;